<!-- Mobile column selector -->
<!-- <div class="block md:hidden mb-4">
  <label class="block mb-2 text-sm font-medium text-gray-700">Choose column</label>
  <select
    [(ngModel)]="selectedColumn"
    name="selectedColumn"
    class="w-full border border-gray-300 rounded-md p-2"
  >
    @for (heading of tableHeadings; track $index) {
      <option [value]="heading">{{ heading }}</option>
    }
  </select>
</div> -->
<div class="overflow-auto">
  <table class="dc-table" [ngClass]="customClass">
    <thead>
      <tr>
        @if (checkbox && listData.length > 0) {
        <th class="w-11">
          <input
            type="checkbox"
            class="peer form-checkbox h-6 w-6 text-dc-navy border-dc-navy accent-dc-navy rounded-none"
            [checked]="allChecked()"
            [indeterminate]="someChecked()"
            (change)="toggleAll($event)"
          />
        </th>
        }
        <!-- @if (!isMobile) { -->
          @for (heading of tableHeadings; track $index) {
          <th>{{ heading | translate }}</th>
          } @if (showActions) {
          <th class="lg:text-center!">
            @if(showActionHeading){ {{ "ACTIONS" | translate }} }
          </th>
          }
        <!-- } -->
        <!-- @else {
          <th>{{ tableHeadings[0] }}</th>
          <th>{{ selectedColumn }}</th>
        } -->
      </tr>
    </thead>
    <tbody>
      <!-- skeleton -->
      @if (loader) {
        @for (_ of [].constructor(pageSize); track $index) {
        <tr class="divide-x divide-slate-300 border-b border-slate-200">
          @for (__ of [].constructor(tableHeadings.length + 1); track $index) {
          <td class="p-4">
            <span
              class="block h-3 w-full rounded bg-slate-200 animate-pulse"
            ></span>
          </td>
          }
        </tr>
        } 
      } @else {        
        @for (row of listData; track $index) {
          <!-- @if (!isMobile) { -->
            <tr>
              @if (checkbox && listData.length > 0) {
              <td>
                <input
                  type="checkbox"
                  class="peer form-checkbox h-6 w-6 text-dc-navy border-dc-navy accent-dc-navy rounded-none hidden lg:block"
                  [checked]="selectedIds.has(row['SR Number'])"
                  (change)="toggleRow(row)"
                />
              </td>
              } 
              @for (key of dataKeys; track $index; let i = $index) {
              <td [attr.data-label]="tableHeadings[i] | translate">
                @switch (key) { 
                  @case ('DC SRType') {
                    <span class="block font-bold">{{ row["DC SRType"] }}</span>
                    <span class="block text-xs text-dc-gray-light">
                      {{
                        row["DC SRSubType"]
                      }}
                    </span>
                  }
                  @case ('SR Type') {
                    <span class="block font-bold">{{ getSRTypeValue(row["SR Type"])}}</span>
                    <span class="block text-xs text-dc-gray-light">
                      {{
                        getSRTypeValue(row["SR Type"], row["SR Sub Type"])
                      }}
                    </span>
                  }
                  @case ('nameWithPosition') {
                  <span class="block font-semibold">{{ row.fullName }}</span>
                  <span class="block text-xs text-dc-gray-light">
                    {{
                      row.position
                    }}
                  </span>
                  }
                  @case ('DC Member Name (English)') {
                  <span class="block">
                    {{
                      row["DC Member Name (English)"]
                    }}
                  </span>           
                  }
                  @case ('DC Created') {
                    {{ row["DC Created"] | date : "dd-MMM-yyyy" }}
                  }
                  @case ('Invoice Date') {
                    {{ row["Invoice Date"] | date : "dd-MMM-yyyy" }}
                  }
                  @case ('Created') {
                    {{ row["Created"] | date : "dd-MMM-yyyy" }}
                  }
                <!-- status -->
                @case ('Status') {
                  @if(row.Status == "Pending"){
                    <!-- Payment status -->
                    <span class="dc-status" [class]="getStatusClass(row.Status)">
                      {{"STATUS.CLOSED" | translate}}
                    </span>
                  }@else {
                    <span class="dc-status" [class]="getStatusClass(row.Status)"> {{ row.Status }} </span>
                  }
                } 
                <!-- Mdiation case -->
                @case ('DC Status') {                 
                    <span class="dc-status" [class]="getStatusClass(row['DC Status'])"> {{ row['DC Status'] }} </span>                  
                } 
                @default {
                  <!-- {{ row[key] ? row[key] : "-" }} -->
                <span [title]="getCellTitle(row[key])">
                  {{ formatCellValue(row[key]) }}
                </span>
                } }
              </td>
              } @if (showActions || otherAction) {
              <td>
                <div class="flex gap-3 justify-end items-center">
                  @if (showActionPay && row.Status ===
                  srStatus.ApprovedAndPaymentAwaited) {
                  <app-button
                    [label]="'BUTTONS.PAY' | translate"
                    [classesName]="'btn-edge-cut btn-primary-small'"
                    (onBtnClick)="onPayClick.emit(row)"
                  ></app-button>
                  }

                  @if (showActionEdit) {
                  <app-button
                    [label]="'BUTTONS.EDIT' | translate"
                    [classesName]="'card-edge-cut-white btn-primary-small'"
                    (onBtnClick)="onEdit.emit(row)"
                  ></app-button>
                  } @if (showActionView) {
                  <app-button
                    [label]="'BUTTONS.VIEW' | translate"
                    [classesName]="'card-edge-cut-white btn-primary-small'"
                    (onBtnClick)="onView.emit(row)"
                  ></app-button>
                  } @if (otherAction) {
                  <app-button
                    [label]="otherActionText"
                    [classesName]="'card-edge-cut-white btn-primary-small'"
                    (onBtnClick)="otherActionClick.emit(row)"
                  ></app-button>
                  } @if (showActionDelete) {
                  <app-button
                    [label]="'BUTTONS.DELETE' | translate"
                    [classesName]="'card-edge-cut-white btn-primary-small'"
                    (onBtnClick)="onDelete.emit(row)"
                  ></app-button>
                  } 
                  @if (showActionMore) {
                    @if (isValidHttpsUrl(row["DC eReceipt Download URL"]) && !restrictSelectionByStatus) {
                    <app-button
                      [label]="'BUTTONS.DOWNLOAD_RECEIPT' | translate"
                      [classesName]="'card-edge-cut-white btn-primary-small'"
                      (onBtnClick)="downloadFileFromUrl(row['DC eReceipt Download URL'])"
                      [iconClass]="'fas fa-download'"
                    ></app-button>
                    }
                    @if((row.Status ==  srStatus.Paid || row.Status ==  srStatus.Closed || row.Status == srStatus.AwaitingCarnetReturn) && isValidHttpsUrl(row["DCDownloadURL"])){
                    <app-button
                    [label]="'BUTTONS.DOWNLOAD_CERTIFICATE' | translate"
                    [classesName]="'card-edge-cut-white btn-primary-small'"
                    (onBtnClick)="openDownloadLink(row['DCDownloadURL'])"
                    [iconClass]="'fas fa-download'"
                  ></app-button>
                    }@else {
                      @if(row.Status ==  srStatus.Paid || row.Status == srStatus.AwaitingCarnetReturn){
                         <app-button
                          [label]="'CERTIFICATE_INPROGRESS' | translate"
                          [classesName]="'card-edge-cut-white btn-primary-small'"
                          (onBtnClick)="false" 
                          [iconClass]="'fas fa-spinner fa-spin'"                     
                        ></app-button>
                      }
                    }
                    @if(restrictSelectionByStatus){
                      <app-button
                        [label]="'BUTTONS.MORE' | translate"
                        [classesName]="'card-edge-cut-white btn-primary-small'"
                        (onBtnClick)="onView.emit(row)"
                        [iconClass]="'fas fa-plus'"
                      ></app-button>
                    }
                  } 
                </div>
              </td>
              }
            </tr>
          }          
          <!-- Mobile row: only show first col + selected -->
          <!-- @else {
              <tr>
              @if (checkbox && listData.length > 0) {
              <td>
                <input
                  type="checkbox"
                  class="peer form-checkbox h-6 w-6 text-dc-navy border-dc-navy accent-dc-navy rounded-none"
                  [checked]="selectedIds.has(row['SR Number'])"
                  (change)="toggleRow(row)"
                />
              </td>
              } 
              <td>{{ row[dataKeys[0]] }}</td>
              <td>{{ row[getKeyFromHeading(selectedColumn)] }}</td>
              </tr>
          } -->

    } @if (!loader && (!listData || listData.length < 1)) {
      <tr>
        <td class="text-center! py-4 text-dc-gray-light italic" colspan="12">
          {{ "NO_RECORD_FOUND" | translate }}
        </td>
      </tr>
      }
    </tbody>
  </table>
</div>


<!-- Pagination -->
@if (showPagination && totalPages > 1 && listData && !loader) {
<app-table-pagenation
  [currentPage]="currentPage"
  [totalPages]="totalPages"
  (prev)="prevPage()"
  (next)="nextPage()"
  (goToPage)="goToPage($event)"
></app-table-pagenation>
}
